<Banner
    closable={true}
    close={lang.main("Close")}
    {type}
    {text}
    {visible}
    successText={lang.main("Success")}
    warningText={lang.main("Warning")}
    on:hidden={handleBannerHidden}
/>

<script>
    import { lang } from "@its-ui/mono/lang/provider";

    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';

    export let type = 'success';
    export let visible = false;

    $: text = type === 'success'
        ? lang.main("Course_info_box_All_changes_have_been_saved")
        : lang.main("An_error_occurred_please_try_again");

    const handleBannerHidden = () => visible = false;
</script>
